//-- Copyright (c) 2021 TMT Insights Group, LLC
import { TitleResponse } from '@/redux/slices/slice_types';
import { Grid, Divider, Typography } from '@tmt-insights/oms_fe_core/material';
import { LabelValue } from '@tmt-insights/oms_fe_core/columns';

const viewingTitle = {
  render: (title: TitleResponse) => <ViewingTitle title={title} />,
  flatTitleStructure: true
};

export default viewingTitle;

const ViewingTitle = ({ title }: { title: TitleResponse }) => {
  const { meta, lineage_meta = {}, release_year, rating, program_id, piece_id } = title.data;

  return (
    <div>
      <Grid container alignItems="center" wrap="nowrap" justifyContent="space-between" sx={{ mt: 4, p: 2, pb: 0 }}>
        <Grid item>
          <Typography variant="h4" sx={{ pr: 1, wordBreak: 'break-word' }}>
            {title?.data?.name} {release_year && <small>({release_year})</small>}
          </Typography>
          <Typography variant="h6" sx={{ pr: 1, wordBreak: 'break-word' }}>
            {lineage_meta.series_name} {lineage_meta.season_number && `S${lineage_meta.season_number}`}
          </Typography>
        </Grid>
      </Grid>

      <Divider />

      <Grid container sx={{ px: 2, py: 3 }} justifyContent="space-between">
        <Grid item>
          <Grid container columnSpacing={5}>
            <LabelValue color="primary" label="Program ID">
              {program_id}
            </LabelValue>
            <LabelValue color="primary" label="Piece ID">
              {piece_id}
            </LabelValue>
            <LabelValue color="primary" label="Rating">
              {rating}
            </LabelValue>
            <LabelValue color="primary" label="Usage">
              {meta?.usage}
            </LabelValue>
            <LabelValue color="primary" label="Content Type">
              {meta?.content_type}
            </LabelValue>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
